type CookieConsentApi = {
  acceptedCategory?: (category: string) => boolean
  run?: (config: unknown) => void
  showPreferences?: () => void
}

let cookieConsentApiPromise: Promise<CookieConsentApi> | null = null

async function getCookieConsentApi(): Promise<CookieConsentApi> {
  if (!cookieConsentApiPromise) {
    cookieConsentApiPromise = Promise.all([
      import('vanilla-cookieconsent'),
      import('vanilla-cookieconsent/dist/cookieconsent.css'),
    ]).then(([module]) => module as unknown as CookieConsentApi)
  }

  return cookieConsentApiPromise
}

export async function runCookieConsent(config: unknown): Promise<void> {
  const cookieConsentApi = await getCookieConsentApi()
  cookieConsentApi.run?.(config)
}

export async function hasCookieConsentCategory(category: string): Promise<boolean> {
  const cookieConsentApi = await getCookieConsentApi()
  return Boolean(cookieConsentApi.acceptedCategory?.(category))
}

export async function openCookieConsentPreferences(): Promise<void> {
  const cookieConsentApi = await getCookieConsentApi()
  cookieConsentApi.showPreferences?.()
  window.CookieConsent?.showPreferences?.()
}
